import React, { createContext, useContext } from 'react';
import { useAlertUI } from '../hooks/useAlertUI';
import { Alert, UserInfo } from '../types';

export interface AlertSystemContextValue {
  alertCount: number;
  allAlerts: Alert[];
  dismissedAlertIds: string[];
  isLoading: boolean;
  refreshAlerts: () => Promise<void>;
  dismissAlert: (alertId: string) => void;
  undismissAlert: (alertId: string) => void;
  isAlertDismissed: (alertId: string) => boolean;
}

const AlertSystemContext = createContext<AlertSystemContextValue | null>(null);

export const useAlertSystem = (): AlertSystemContextValue => {
  const context = useContext(AlertSystemContext);
  if (!context) {
    throw new Error('useAlertSystem must be used within AlertSystemProvider');
  }
  return context;
};

export const useAlertSystemOptional = (): AlertSystemContextValue | null => {
  return useContext(AlertSystemContext);
};

interface AlertSystemProviderProps {
  userInfo?: UserInfo | null;
  children: React.ReactNode;
}

export const AlertSystemProvider: React.FC<AlertSystemProviderProps> = ({ userInfo = null, children }) => {
  const alertState = useAlertUI(userInfo);

  return <AlertSystemContext.Provider value={alertState}>{children}</AlertSystemContext.Provider>;
};
